import React from "react";
import { ChatMessage } from "@lifeat/shared/rooms/room-chat/RoomChatTypes";
import { PublicUserInfoForRoom } from "../RoomChatTypes";
import MessageBubble from "./MessageBubble";

interface ChatMessageBubbleProps {
    readonly messageId: string;
    readonly message: ChatMessage["message"];
    readonly authorInfo: PublicUserInfoForRoom | undefined;
    readonly timeStamp: ChatMessage["sentTimestamp"];
    readonly isInteractingBlocked: boolean;
    readonly sending?: boolean;
}
export default function ChatMessageBubble(props: ChatMessageBubbleProps) {
    return (
        <MessageBubble
            messageId={props.messageId}
            message={props.message}
            authorInfo={props.authorInfo}
            timeStamp={props.timeStamp}
            isInteractingBlocked={props.isInteractingBlocked}
            sending={props.sending}
        />
    );
}
